module.exports = __webpack_public_path__ + "img/IMG_2401.a02748e6.jpg";